import axios from 'axios';
import {getVotesCategoryStore} from './vote-store';
import { User } from '../components/register-form';
import { CATEGORIES } from '../enums/categories';

export const getNominations = async () => {
    return await axios.get('/api/nomination');
    
}

export const submitVote = async (user: User) => {
    // When validation passes add a csrf token
    // POST request to an endpoint
    // On success we can trigger some message, hide the registration form, etc
    // On error we need to show some sort of error -> has somebody voted with this email already?
    // @ts-ignore
    const token = document.querySelector("meta[name=csrf-token]").content;
    return axios.post('api/register-vote',
    {
        firstName: user.Firstname,
        lastName: user.Lastname,
        city: user.City,
        phone: user.Phone,
        emailAddress: user.Email,
        gdpr: user.AgreeGDPR,
        terms: user.AgreeGeneralTerms,
        categoryVotes: {
            [CATEGORIES.BG_PESEN]: getVotesCategoryStore(CATEGORIES.BG_PESEN),
            [CATEGORIES.BG_TEKST]: getVotesCategoryStore(CATEGORIES.BG_TEKST),
            [CATEGORIES.BG_ALBUM]: getVotesCategoryStore(CATEGORIES.BG_ALBUM),
            [CATEGORIES.BG_IZPALNITEL]: getVotesCategoryStore(CATEGORIES.BG_IZPALNITEL),
            [CATEGORIES.BG_IZPALNITELKA]: getVotesCategoryStore(CATEGORIES.BG_IZPALNITELKA),
            [CATEGORIES.BG_KOMBINACIA]: getVotesCategoryStore(CATEGORIES.BG_KOMBINACIA),
            [CATEGORIES.BG_VOKALNA_GRUPA]: getVotesCategoryStore(CATEGORIES.BG_VOKALNA_GRUPA),
            [CATEGORIES.BG_GRUPA]: getVotesCategoryStore(CATEGORIES.BG_GRUPA),
            [CATEGORIES.BG_DEBUT]: getVotesCategoryStore(CATEGORIES.BG_DEBUT),
            [CATEGORIES.BG_VIDEOKLIP]: getVotesCategoryStore(CATEGORIES.BG_VIDEOKLIP),
        }
    }, {
        headers: {
            'X-CSRF-Token': token,
            'Content-Type': 'application/x-www-form-encoded'
        },
    }).then(res => {
        return res.data;
    }).catch(err => {
        console.log(err)
    })
    
}
